import styles from '../../return-to-checkout-modal.module.css'
import { ModalState } from '../../return-to-checkout-modal.types'
import { VehicleInformation } from '../../vehicle-information/vehicle-information.component'
import { ReturnToCheckoutCardProps } from '../types'
import { Secondary, Text } from '@cinch-labs/design-system'
import React, { useEffect } from 'react'
import { trackEventCallback } from '../../return-to-checkout-modal.types'

export interface ReturnToCheckoutExpiredUnavailableProps
  extends ReturnToCheckoutCardProps {
  i18n: {
    text: string
    buttonText: string
  }
  adminFeeFlag: boolean
  adminFeeValueInPence: number
  noOpTracking: trackEventCallback
  trackEvent?: trackEventCallback
  onModalOpen: (modalState: ModalState) => void
}

export const ReturnToCheckoutExpiredUnavailable: React.FC<
  ReturnToCheckoutExpiredUnavailableProps
> = ({
  i18n,
  vehicle,
  onButtonClick,
  title,
  isButtonLoading,
  adminFeeFlag,
  adminFeeValueInPence,
  noOpTracking,
  trackEvent,
  onModalOpen,
}) => {
  useEffect(() => {
    onModalOpen(ModalState.expiredUnavailable)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={styles.contentWrapper}>
      {title}
      <VehicleInformation
        vehicle={vehicle}
        hidePrice={true}
        grayscale={true}
        adminFeeFlag={adminFeeFlag}
        adminFeeValueInPence={adminFeeValueInPence}
        noOpTracking={noOpTracking}
        trackEvent={trackEvent}
      />

      <Text
        className={styles.expiredUnavailableText}
        fontWeight={'light'}
        fontSize={'s'}
      >
        {i18n.text}
      </Text>

      <Secondary
        isLoading={isButtonLoading}
        onClick={onButtonClick}
        size="large"
        isFullWidth={true}
      >
        {i18n.buttonText}
      </Secondary>
    </div>
  )
}
